type GenericObject = { [key: string]: any }

export const PROJECT_ALERTS_LOAD = 'PROJECT_ALERTS_LOAD'
export const projectAlertsLoad = (
  accountId: string,
  projectId: string,
  filter: GenericObject
): AlertsLoadAction => ({
  type: PROJECT_ALERTS_LOAD,
  accountId,
  projectId,
  filter
})

export const PROJECT_ALERTS_LOAD_SUCCESS = 'PROJECT_ALERTS_LOAD_SUCCESS'
export const projectAlertsLoadSuccess = (
  accountId: string,
  projectId: string,
  alerts: GenericObject[]
): AlertsLoadSuccessAction => ({
  type: PROJECT_ALERTS_LOAD_SUCCESS,
  accountId,
  projectId,
  alerts
})

export const PROJECT_ALERTS_LOAD_FAIL = 'PROJECT_ALERTS_LOAD_FAIL'
export const projectAlertsLoadFailure = (
  accountId: string,
  projectId: string,
  error
): AlertsLoadFailAction => ({
  type: PROJECT_ALERTS_LOAD_FAIL,
  accountId,
  projectId,
  error
})

export const PROJECT_ALERT_CLIENT_DISMISS = 'PROJECT_ALERT_CLIENT_DISMISS'
export const projectAlertClientDismiss = (
  accountId: string,
  projectId: string,
  projectAlertId: string,
  onSuccess: () => void,
  onFailure: (error: any) => void
) => ({
  type: PROJECT_ALERT_CLIENT_DISMISS,
  accountId,
  projectId,
  projectAlertId,
  callbacks: { onSuccess, onFailure }
})

export const PROJECT_ALERT_CLIENT_DISMISS_BULK =
  'PROJECT_ALERT_CLIENT_DISMISS_BULK'
export const projectAlertClientDismissBulk = (
  accountId: string,
  projectId: string,
  projectAlertIds: string[],
  onSuccess: () => void,
  onFailure: (error: any) => void
) => ({
  type: PROJECT_ALERT_CLIENT_DISMISS_BULK,
  accountId,
  projectId,
  projectAlertIds,
  callbacks: { onSuccess, onFailure }
})

// INTERFACEs
export interface AlertsLoadAction {
  type: typeof PROJECT_ALERTS_LOAD
  accountId: string
  projectId: string
  filter: GenericObject
}

interface AlertsLoadSuccessAction {
  type: typeof PROJECT_ALERTS_LOAD_SUCCESS
  accountId: string
  projectId: string
  alerts: GenericObject[]
}

interface AlertsLoadFailAction {
  type: typeof PROJECT_ALERTS_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}

export interface ProjectAlertClientDismissAction {
  type: typeof PROJECT_ALERT_CLIENT_DISMISS
  accountId: string
  projectId: string
  projectAlertId: string
  callbacks: {
    onSuccess: () => void
    onFailure: (error: any) => void
  }
}

export interface ProjectAlertClientDismissBulkAction {
  type: typeof PROJECT_ALERT_CLIENT_DISMISS_BULK
  accountId: string
  projectId: string
  projectAlertIds: string[]
  callbacks: {
    onSuccess: () => void
    onFailure: (error: any) => void
  }
}
